import Header from "@/components/Header";
import Contact from "@/components/Contact";
import FaqSection from "@/components/FaqSection";

const Venue = () => {
  return (
    <>
      <Header />

      <Contact />

      {/* <Endorsement /> */}

      {/* Important Dates */}
      {/* <section className="py-16 bg-blue-600 text-white">
        <h2 className="text-4xl font-bold text-center mb-12">
          Important Dates
        </h2>
        <ul className="space-y-4 text-lg text-center">
          <li>Abstract Submission Deadline: August 1, 2025</li>
          <li>Notification of Acceptance: September 1, 2025</li>
          <li>Early Bird Registration Deadline: October 1, 2025</li>
          <li>Conference Dates: November 6-8, 2025</li>
        </ul>
      </section> */}

      {/* FAQ Section */}
      <FaqSection />
    </>
  );
};

export default Venue;
